import { PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { AuthService, RouteService } from '@/shared/services';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';
import { catchError, map, of, switchMap } from 'rxjs';
import { TrackingService } from '@/shared/services/tracking.service';

export function onAuthGuard(permission: string): CanActivateFn {
  return (route: ActivatedRouteSnapshot) => {
    const authService = inject(AuthService);
    const routeService = inject(RouteService);
    const trackingService = inject(TrackingService);
    const platformId = inject(PLATFORM_ID);

    if (!isPlatformBrowser(platformId)) {
      return false;
    }

    // return of(true);
    // If token has value, which means it's from SSO, load the user using it. If not,
    // the user already logged in, and use the token in localStorage to authenticate
    const token = route.queryParams['auth'] as string | undefined;

    if (token) {
      authService.saveToken(token);
    }

    return authService.loadUser().pipe(
      switchMap((user) => {
        if (!user) {
          routeService.navigate(environment['login_url']);
          return of(false);
        }
        authService.saveToken(user.token!);
        trackingService.trackNavigation();

        return authService.getFullPermissionList().pipe(
          map(() => {
            if (authService.hasPermission(permission, true)) {
              return true;
            } else {
              routeService.navigate('home');
              return false;
            }
          }),
        );
      }),
      catchError(() => {
        routeService.navigate(environment['login_url']);
        return of(false);
      }),
    );
  };
}
